<tt-page>
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-list [ttData]="itemsListCsvExports"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="csvexports_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-list [ttData]="itemsListCsvExports"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
